'use strict';

/**
 * Collection of functions related with product promotions.
 */
var base = {};

// Module Includes
var moment = require('moment');

// Constants
var ATTRIBUTES = {
    CLASSES: {
        PROMOTION_DISCLAIMER: '.com-pdp-promotion-disclaimer'
    },
    ELEMENTS: {
        BODY: 'body',
        SPAN: 'span'
    },
    DATES: {
        DEFAULT: 'DD/MM/YYYY'
    },
    EMPTY_STRING: ''
};

/**
 * Renders the promotion disclaimer if the promotion start and end date are set.
 */
function renderPromotionMessage() {
    // Select the promotion main element
    var $promotionElement = $(ATTRIBUTES.CLASSES.PROMOTION_DISCLAIMER);

    $promotionElement.each(function (index, element) {
        // Get the <span> inside the <div>
        const messageElement = element.querySelector(ATTRIBUTES.ELEMENTS.SPAN);

        // Using moment library to format the date format
        const startDate = element.dataset.start ? moment(element.dataset.start).format(ATTRIBUTES.DATES.DEFAULT) : ATTRIBUTES.EMPTY_STRING;
        const endDate = element.dataset.end ? moment(element.dataset.end).format(ATTRIBUTES.DATES.DEFAULT) : ATTRIBUTES.EMPTY_STRING;

        var message = element.dataset.message ? element.dataset.message : ATTRIBUTES.EMPTY_STRING;

        if (startDate !== ATTRIBUTES.EMPTY_STRING && endDate !== ATTRIBUTES.EMPTY_STRING && message !== ATTRIBUTES.EMPTY_STRING) {
            message = message.replace('{0}', startDate).replace('{1}', endDate);
        } else {
            message = ATTRIBUTES.EMPTY_STRING;
        }

        // Assign the formatted message to the <span>
        messageElement.textContent = message;
    });
}

/**
 * Collection of custom event definitions.
 */
var customEvents = {
    /**
     * Attach a custom event to render a product promotion message.
     */
    renderPromotionMessage: function () {
        $('body').on('product:renderPromotionMessage', function () {
            renderPromotionMessage();
        });
    }
};

/**
 * Attach every event listener related with the store selector to the DOM.
 */
function attachEventListeners() {
    customEvents.renderPromotionMessage();
}

/**
 * Expose functions
 */
base.attachEventListeners = attachEventListeners;
base.renderPromotionMessage = renderPromotionMessage;

module.exports = base;
